import "MWL@2026/presentation/styles";
import "MWL@2026/presentation/capabilities";

import "MWL@2026/widgets/code/code-script";